import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class RemoveKundorderradLagerplatserCommand extends BasicCommand<RemoveKundorderradLagerplatserCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<RemoveKundorderradLagerplatserCommand>;
    kundorderradId: number;
    lagerplatser: number[];

    constructor(kundorderradId: number) {
        super("RemoveKundorderradLagerplatserCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
    }
}
